import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnknown = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M7.33333 14.4834V8.38337L2 5.30004V10.65C2 10.8945 2.05833 11.1167 2.175 11.3167C2.29167 11.5167 2.45556 11.6778 2.66667 11.8L7.33333 14.4834ZM8.66667 14.4834L13.3333 11.8C13.5444 11.6778 13.7083 11.5167 13.825 11.3167C13.9417 11.1167 14 10.8945 14 10.65V5.30004L8.66667 8.38337V14.4834ZM11.3167 5.31671L13.2833 4.16671L8.66667 1.51671C8.45556 1.39449 8.23333 1.33337 8 1.33337C7.76667 1.33337 7.54444 1.39449 7.33333 1.51671L6.01667 2.26671L11.3167 5.31671ZM8 7.23337L9.98333 6.10004L4.7 3.03337L2.7 4.18337L8 7.23337Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgUnknown);
export default ForwardRef;
